import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const AgronomistAdminWrapper = styled.div`
  .settings-section {
    background: white;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 16px;
  }

  .settings-section h3 {
    margin-bottom: 16px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 8px;
  }

  .settings-section .ant-form-item {
    margin-bottom: 16px;
  }

  .save-button {
    margin-top: 16px;
  }
`;

export default WithDirection(AgronomistAdminWrapper);
